import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'core/types/crudStore'

import { mapPartnerFromPartnerAllDataRegions } from './mapping/mapPartnerFromPartnerAllDataRegions'

export const fetchPartnerRequestById = async (partnerId: string, options?: ICrudFetchOptions) => {
  const partnerCrud = CrudStore.get(CrudStoreItem.PartnerAllData, options?.cacheKey)
  return partnerCrud
    .getById({ id: partnerId, force: options?.isForce, keyField: 'PartnerID' })
    .then((result: IForm) => result && mapPartnerFromPartnerAllDataRegions(result))
}
